'use client'

import React, { useEffect, useState } from 'react';
import { activities, pendingApprovals, stats } from './data';
import { useDispatch, useSelector } from 'react-redux';
import { authSelector } from '@/components/features/selectors/authSelector';
import { changeUserStatusThunk, getUsersListThunk } from '@/components/features/thunks/userThunk';
import { getAdminAnalyticsThunk } from '@/components/features/thunks/analyticsThunk';
import { userSelector } from '@/components/features/selectors/userSelector';
import { analyticsSelector } from '@/components/features/selectors/analyticsSelector';
import { InputSwitch } from 'primereact/inputswitch';
import { Paginator } from 'primereact/paginator';
import Swal from 'sweetalert2';


const page = () => {
  const dispatch = useDispatch();
  const { token } = useSelector(authSelector);
  const { users, limit, page: currentPage, total, totalPages } = useSelector(userSelector);
  const { stats: dashboardStats } = useSelector(analyticsSelector);

  const handlePageChange = (e) => {
    getUsersList({ page: e.page + 1, limit: e.rows })
  }
  // const users=[]
  useEffect(() => {
    getUsersList();
    getDashboardStats();
  }, [token])

  const getUsersList = async (params = null) => {
    await dispatch(getUsersListThunk({ token, params }))
  }

  const getDashboardStats = async () => {
    await dispatch(getAdminAnalyticsThunk({ token }));
  }

  const handleStatus = async (userId, is_active) => {
    console.log("sjfcn", userId, is_active);

    // Show confirmation alert
    const result = await Swal.fire({
      title: 'Are you sure?',
      text: is_active ? "You want to activate this user?" : "You want to deactivate this user?",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
    });

    if (result.isConfirmed) {
      // Call your thunk only if user confirms
      const resp = await dispatch(changeUserStatusThunk({ token, data: { is_active }, userId }));
      console.log("resp", resp)
      if (resp?.payload?.success) {
        getUsersList();
      }

      // Success message
      Swal.fire({
        title: 'Success!',
        text: `User has been ${is_active ? 'activated' : 'deactivated'}.`,
        icon: 'success',
        timer: 1500,
        showConfirmButton: false
      });
    }
  };


  return (

    <main className="!flex-1 !overflow-y-auto !p-8">
      <div className="!max-w-7xl !mx-auto">

        <div className="!flex !justify-between !items-end !mb-8">
          <div>
            <h2 className="!text-2xl !font-bold !text-gray-800">Dashboard Overview</h2>
            <p className="!text-gray-500">Welcome back, here's what's happening today.</p>
          </div>
          {/* <button className="!px-4 !py-2 !bg-blue-600 !text-white !rounded-lg !shadow-lg hover:!bg-blue-700 !transition-colors !font-medium !flex !items-center !gap-2">
                <i className="pi pi-plus"></i> New Booking
              </button> */}
        </div>

        {/* 1. Overview Stats Cards */}
        <div className="!grid !grid-cols-1 md:!grid-cols-2 lg:!grid-cols-4 !gap-6 !mb-8">
          {[
            {
              title: "Total Bookings",
              value: dashboardStats ? (dashboardStats.totalFlights + dashboardStats.totalHotels).toLocaleString() : "...",
              sub: `${dashboardStats?.totalHotels || 0} Hotels, ${dashboardStats?.totalFlights || 0} Flights`,
              icon: "pi pi-ticket",
              color: "!bg-blue-600",
              trend: "+12.5%",
              trendColor: "text-green-500"
            },
            {
              title: "Today's Revenue",
              value: dashboardStats ? `$${parseFloat(dashboardStats.todayRevenue).toLocaleString()}` : "...",
              sub: "Real-time earnings today",
              icon: "pi pi-dollar",
              color: "!bg-emerald-500",
              trend: "+8.2%",
              trendColor: "text-green-500"
            },
            {
              title: "Weekly Revenue",
              value: dashboardStats ? `$${parseFloat(dashboardStats.weeklyRevenue).toLocaleString()}` : "...",
              sub: "Last 7 days total",
              icon: "pi pi-chart-line",
              color: "!bg-violet-600",
              trend: "-2.4%",
              trendColor: "text-red-500"
            },
            {
              title: "Pending Approvals",
              value: dashboardStats?.pendingApprovals || 0,
              sub: "Requires immediate attention",
              icon: "pi pi-clock",
              color: "!bg-amber-500",
              trend: "Urgent",
              trendColor: "text-amber-600"
            }
          ].map((stat, idx) => (
            <div key={idx} className="!bg-white !rounded-2xl !p-6 !shadow-sm !border !border-gray-100 !transition-transform hover:!scale-[1.02] !cursor-default">
              <div className="!flex !justify-between !items-start !mb-4">
                <div className={`${stat.color} !w-12 !h-12 !flex !items-center !justify-center !rounded-xl !shadow-lg`}>
                  <i className={`${stat.icon} !text-white !text-xl`}></i>
                </div>
                <span className={`!text-sm !font-bold ${stat.trendColor} !bg-gray-50 !px-2 !py-1 !rounded-md`}>
                  {stat.trend}
                </span>
              </div>
              <h3 className="!text-gray-500 !text-sm !font-medium">{stat.title}</h3>
              <div className="!text-2xl !font-bold !text-gray-800 !mt-1">{stat.value}</div>
              <p className="!text-xs !text-gray-400 !mt-2">{stat.sub}</p>
            </div>
          ))}
        </div>


      </div>
    </main>

  );
};

export default page;